<script>
  export let href
</script>

<a {href} {...$$restProps} class={$$props.class}>
  <slot />
</a>
